export default "__VITE_ASSET__DJM5Y8gw__"